import { exposed, fromNode, ViewModel } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { VariableNode } from './TypedNode'

export class VariableModel extends ViewModel {
  /*
   * 变量的状态，最初始的值来自于用户设置 defaultValue
   */
  @fromNode()
  @reactive()
  defaultValue: any = undefined

  @exposed()
  @reactive()
  value = this.defaultValue

  constructor(node: VariableNode) {
    super(node)

    this.addReaction(
      () => this.defaultValue,
      (value) => {
        this.value = value
      }
    )
  }

  /*
   * 更新变量值
   */
  @exposed()
  setValue(value: any) {
    this.value = value
  }
}
